import API from "./api";

/* =========================================================
   NOTIFICATION API
   Wraps both the legacy /api/notifications endpoints and the
   new Notification Center (search/filter/pagination/delete).
========================================================= */

const userId = () => localStorage.getItem("userId");

// Legacy simple list (kept for backward compatibility)
export const getNotifications = () =>
  API.get("/notifications", { params: { user_id: userId() } });

export const getUnreadCount = () =>
  API.get(`/notifications/unread/${userId()}`);

// Notification Center: search + filter + pagination
// filters: { search, type, sender_id, date_from, date_to, page, limit }
export const getNotificationCenter = (filters = {}) =>
  API.get(`/notifications/center/${userId()}`, { params: filters });

export const markAsRead = (id) => API.put(`/notifications/read/${id}`);

export const markAllRead = () => API.put(`/notifications/read-all/${userId()}`);

export const deleteNotification = (id) => API.delete(`/notifications/${id}`);

export default {
  getNotifications,
  getUnreadCount,
  getNotificationCenter,
  markAsRead,
  markAllRead,
  deleteNotification,
};
